import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MemberAuthContext = createContext(null);
export const formatApiError = (detail) => Array.isArray(detail) ? detail.map(item => item?.msg || String(item)).join(" ") : (typeof detail === "string" ? detail : "Something went wrong. Please try again.");

export function MemberAuthProvider({ children }) {
  const location = useLocation();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const checkAuth = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/member/auth/me`, { withCredentials: true });
      setMember(response.data);
    } catch {
      try {
        await axios.post(`${API}/member/auth/refresh`, {}, { withCredentials: true });
        const response = await axios.get(`${API}/member/auth/me`, { withCredentials: true });
        setMember(response.data);
      } catch { setMember(null); }
    } finally { setLoading(false); }
  }, []);
  useEffect(() => {
    if (!location.pathname.startsWith("/member")) { setLoading(false); return; }
    setLoading(true);
    checkAuth();
  }, [checkAuth, location.pathname]);
  const login = async (email, password) => {
    const response = await axios.post(`${API}/member/auth/login`, { email, password }, { withCredentials: true });
    setMember(response.data); return response.data;
  };
  const logout = async () => { await axios.post(`${API}/member/auth/logout`, {}, { withCredentials: true }); setMember(null); };
  return <MemberAuthContext.Provider value={{ member, setMember, loading, login, logout, checkAuth }}>{children}</MemberAuthContext.Provider>;
}
export const useMemberAuth = () => useContext(MemberAuthContext);